/**
 * Admin → Devices and Quarantine (Phase 16C C11, backend 16B B9). Two routes:
 *   GET  /admin/offline?view=devices | quarantine
 *   POST /admin/offline { action, ... }
 */
import { apiClient } from '../api-client';
import type {
  OfflineDeviceDto,
  OfflineDevicesResponse,
  QuarantineDecisionRequest,
  QuarantineDecisionResponse,
  QuarantineItemDto,
  QuarantineResponse,
  RevokeDeviceRequest,
} from '../../dtos/offline/offlineAdmin.dto';

const ENDPOINT = '/admin/offline';
export const REASON_MIN = 10;
export const REASON_MAX = 500;

export class OfflineAdminService {
  static async listDevices(): Promise<OfflineDeviceDto[]> {
    const response = await apiClient.get<OfflineDevicesResponse>(ENDPOINT, { view: 'devices' });
    return response.data?.devices || [];
  }

  static async listQuarantine(): Promise<QuarantineItemDto[]> {
    const response = await apiClient.get<QuarantineResponse>(ENDPOINT, { view: 'quarantine' });
    return response.data?.items || [];
  }

  static async revokeDevice(userId: string, deviceId: string): Promise<void> {
    const body: RevokeDeviceRequest = { action: 'revokeDevice', userId, deviceId };
    await apiClient.post(ENDPOINT, body);
  }

  static async decideQuarantine(action: QuarantineDecisionRequest['action'], patientId: string, opId: string, reason: string): Promise<QuarantineDecisionResponse> {
    const trimmed = reason.trim();
    if (trimmed.length < REASON_MIN || trimmed.length > REASON_MAX) throw new Error(`Enter a reason of ${REASON_MIN}–${REASON_MAX} characters`);
    const body: QuarantineDecisionRequest = { action, patientId, opId, reason: trimmed };
    const response = await apiClient.post<QuarantineDecisionResponse>(ENDPOINT, body);
    return response.data;
  }
}

export default OfflineAdminService;
